import { useEffect, useState } from 'react';
import { discoverMetadataMpts } from '../lib/discovery.js';

const initialState = {
  status: 'loading',
  programs: [],
  supplies: [],
  totalMpts: 0,
  discoveredAt: null,
  error: null,
};

export function useMptDiscovery() {
  const [state, setState] = useState(initialState);

  useEffect(() => {
    const controller = new AbortController();
    discoverMetadataMpts(controller.signal)
      .then((result) => setState({ status: 'ready', error: null, ...result }))
      .catch((error) => {
        if (error.name !== 'AbortError') {
          setState((current) => ({ ...current, status: 'error', error: error.message }));
        }
      });
    return () => controller.abort();
  }, []);

  return state;
}
